// extracted by mini-css-extract-plugin
export const home__songs = "HomeSongsList-module--home__songs--1fACo";
export const home__view_more_button = "HomeSongsList-module--home__view_more_button--3ERN2";